<template>
  <v-jumbotron>
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h4 class="display-2 my-3">
            Navigation
          </h4>
<!--           <span class="subheading">
            <h3>Info about the Challenge</h3>
          </span> -->
          <span class="subheading">
            Use the navigation panel to access links to various pages and functions for this challenge: read information about the challenge and dataset, work through tutorials, download data, make submissions, and view the leaderboard. You can display the navigation panel at any time by clicking on the menu button (<v-icon>menu</v-icon>) at top left. To close the navigation panel, click anywhere away from the panel. 
          </span>
          <v-divider class="my-3"></v-divider>
          <!-- <div class="title my-4">?</div> -->
          <v-btn color="primary" dark class="mx-0" to="tour2">Next</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>

</template>

<script>
  export default {
    name: 'Tour1',
    data () {
      return {
        // foo: 'bar'
        // gradient: '315deg, #3f87a6, #f69d3c',
      }
    },
    mounted () {
      // console.log('Tour1 component mounted')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Tour/Tour1.vue